import { useQuery } from '@apollo/react-hooks';
import get from 'lodash/get';


const FetchPageData = ({ match, query, type }) => {
  const pageId = get(match, 'params.id', false);
  const { data, loading, refetch } = useQuery(query, {
    variables: {
      id: pageId,
    },
  });

  const pageInfo = get(data, type, false);

  return { loading, pageInfo, refetch };
};

const usePageInfo = ({
  match,
  query,
  type,
}) => {
  const { loading, pageInfo, refetch } = FetchPageData({ match, query, type });

  return { pageInfo, loading, refetch };
};

export default usePageInfo;
